import type { CSSProperties, HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

const checkerboardStyle: CSSProperties = {
  backgroundColor: '#d6d3d1',
  backgroundImage: [
    'linear-gradient(45deg, #fafaf9 25%, transparent 25%)',
    'linear-gradient(-45deg, #fafaf9 25%, transparent 25%)',
    'linear-gradient(45deg, transparent 75%, #fafaf9 75%)',
    'linear-gradient(-45deg, transparent 75%, #fafaf9 75%)',
  ].join(', '),
  backgroundSize: '16px 16px',
  backgroundPosition: '0 0, 0 8px, 8px -8px, -8px 0',
};

type Props = HTMLAttributes<HTMLDivElement>;

export default function Checkerboard({ className, style, ...props }: Props) {
  return <div className={cn('overflow-hidden', className)} style={{ ...checkerboardStyle, ...style }} {...props} />;
}
